export default __webpack_public_path__ + "static/Toxina-Botulinica-b8ccc9cfd9bc13aa1892ff09c330e24d.svg";